import { LoadingOutlined } from "@ant-design/icons";
import "./LogoLoading.style.scss";
import Logo from "assets/images/logo-blue.png";
import { CSSProperties } from "styled-components";

type P_Props = {
  style?: CSSProperties;
};

const LogoLoadingPresenter = (props: P_Props) => {
  return (
    <div className="logo-loading" style={{ ...props.style }}>
      <div className="logo-loading_item">
        <img src={Logo} alt="logo" className="logo-loading_item-img" />
        <LoadingOutlined className="logo-loading_item-loading" />
      </div>
    </div>
  );
};

export default LogoLoadingPresenter;
